import React, { useMemo, useState } from "react";
import LeadsHeader from "../Lead/LeadsHeader";
import "../css/Leads.css"; // Ensure this path is correct
// import Register from "../Register";
// import CallbackComponent from "../Lead/callbackcomponent";
// import HotLead from "../Lead/Hotlead";
// import AnsweringComponent from "../Lead/AnsweringComponent"
// import NotInterestedComponent from "../Lead/NotIntrestedComponent";
// import SoldComponent from "../Lead/SoldComponent";
// import ApproveComponent from "../Lead/ApproveComponent";
import AdminResetPassword from "./AdminResetPassword";

/**
 * Props:
 *  - tabs: {
 *      overview?: ReactNode,
 *      list?: ReactNode,
 *      board?: ReactNode,
 *      calendar?: ReactNode,
 *      files?: ReactNode
 *    }
 * If no tabs prop is provided, we'll show a simple placeholder.
 */
export default function AdminIndex({ tabs = {} }) {
  const [active, setActive] = useState("Password Reset");

  const tabItems = useMemo(
    () => ([
      // { key: "Overview", node:  <Index /> },
      { key: "Password Reset",      node: <AdminResetPassword /> },
      // { key: "Register",     node: <Register /> },
      // { key: "Answering",  node: <AnsweringComponent /> },
      // { key: "Not Interested",     node: <NotInterestedComponent /> },
      // { key: "Sold",     node: <SoldComponent /> },
      // { key: "Approve",     node: <ApproveComponent /> },
    ]),
    [tabs]
  );

  const ActiveView =
    tabItems.find(t => t.key === active)?.node ??
    <p className="placeholder">Add a component for the “{active}” tab…</p>;

  return (
    <div className="leads">
      <LeadsHeader />

      <div className="leads-body">
        {/* Tabs header */}
        <div className="tabs">
          <div className="tabs-left">
            {tabItems.map(({ key }) => (
              <button
                key={key}
                className={`tab ${active === key ? "is-active" : ""}`}
                onClick={() => setActive(key)}
                role="tab"
                aria-selected={active === key}
              >
                {key}
              </button>
            ))}
          </div>

          <div className="tabs-right">
            {/* Optional right-side actions (match your reference UI) */}
            {/* <button className="btn btn-primary">+ Add New</button> */}
          </div>
        </div>

        {/* Optional filter strip (shown only on List tab per your image) */}
        {active === "List" && (
          <div className="filter-bar">
            <button className="chip">Due Date <span className="chip-value">March 17 – 20</span></button>
            <button className="chip">Assignee <span className="chip-value">All</span></button>
            <button className="chip">Priority <span className="chip-value">All</span></button>
            <button className="btn btn-soft">Advance Filters</button>
          </div>
        )}

        {/* Active tab content */}
        <div className="tab-panel" role="tabpanel">
          {ActiveView}
        </div>
      </div>
    </div>
  );
}
